import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-delegate-explanation-mobile',
    templateUrl: './delegate-explanation-mobile.component.html',
    styleUrls: ['./delegate-explanation-mobile.component.scss'],
    standalone: false
})
export class DelegateExplanationMobileComponent implements OnInit {
  public collapseMobile;
  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
